module.exports = __webpack_public_path__ + "static/prodinity_main_3-49282b37c5d67c806151e2d0539fc5f2.png";